import { Component, OnInit } from '@angular/core';

import { Subject } from 'rxjs';
import { GroupedPageContainerComponent } from '../../../layout/grouped-page-container/grouped-page-container.component';
import { Props, TabGroupConfig } from '../../../model/form.model';
import { createImpactAnalysisNewTabsConfig } from '../../../model/impact-analysis-new.model';

@Component({
  selector: 'app-impact-analysis',
  standalone: true,
  imports: [GroupedPageContainerComponent],
  templateUrl: './impact-analysis.component.html',
  styleUrl: './impact-analysis.component.scss'
})
export class ImpactAnalysisComponent implements OnInit {
  private selectedAreaTab: any = null;

  title = 'Impact Analysis';
  props: Props = { isTabStretch: false };

  private readonly tabsConfig = createImpactAnalysisNewTabsConfig();
  private readonly clonedAreaTabs = this.tabsConfig.areaTabs;
  private readonly clonedLeadersTabs = this.tabsConfig.leadersTabs;

  groups: TabGroupConfig[] = this.tabsConfig.groups;

  ngOnInit() {
    this.initializeTabs();
  }

  private initializeTabs() {
    this.clonedAreaTabs.forEach((tab, _index) => {
      tab['tabOnChangeSubject'] = new Subject();
      tab['tabOnChangeSubject'].subscribe(() => {
        this.selectedAreaTab = tab;
        this.clearTabFilters([tab]);
      });
    });
    this.clonedLeadersTabs.forEach((tab) => {
      tab['tabOnChangeSubject'] = new Subject();
      tab['tabOnChangeSubject'].subscribe(() => {
        this.clearTabFilters([tab]);
      });
    });
    const firstAreaTab = this.clonedAreaTabs[0];
    if (firstAreaTab) {
      this.selectedAreaTab = firstAreaTab;
      if (firstAreaTab?.['tabOnChangeSubject']) {
        firstAreaTab['tabOnChangeSubject'].next(null);
      }
    }
    const firstLeadersTab = this.clonedLeadersTabs[0];
    if (firstLeadersTab?.['tabOnChangeSubject']) {
      firstLeadersTab['tabOnChangeSubject'].next(null);
    }
  }

  private clearTabFilters(tabs: any[]): void {
    tabs.forEach((tab) => {
      tab.inputs?.gridSchema?.forEach((grid: any) => {
        if (grid.inputs?.DataTableSchema) {
          grid.inputs.DataTableSchema.inputFilter = '';
        }
      });
    });
  }

  onGroupChange(index: number) {
    if (index === 1) {
      this.clearTabFilters(this.clonedLeadersTabs);
      const firstLeadersTab = this.clonedLeadersTabs[0];
      if (firstLeadersTab?.['tabOnChangeSubject']) {
        firstLeadersTab['tabOnChangeSubject'].next(null);
      }
    } else {
      this.clearTabFilters(this.clonedAreaTabs);
    }
  }
}